const Inicio = () => import('../components/Views/Aprendizagem/Acervo/Inicio.vue');
const Galeria = () => import('../components/Views/Aprendizagem/Acervo/Galeria.vue');
import auth from '../middleware/auth'

const breadcrumb = [
  { name: 'Integrado', link: process.env.INTERNO_URL },
  { name: 'Aprendizagem', link: '/aprendizagem' },  
];

const aprendizagem = [
  {
    path: '/aprendizagem',
    component: Inicio,
    name: 'Acervo de Fotos',
    meta: {
      middleware: auth,
      breadcrumb
    }
  },
  {
    path: `/aprendizagem/:id`,
    component: Galeria,
    name: 'Galeria',
    meta: {
      middleware: auth,
      breadcrumb
    }
  }
];

export default aprendizagem;



// WEBPACK FOOTER //
// ./src/routes/aprendizagem.js